import React from "react";
import { useLang } from "@/lib/lang";

export default function Marquee({ text }) {
  const { t } = useLang();
  const content = t(text) || "REMODELING · CLEANING · RALEIGH · NC · SINCE 2020";
  const line = new Array(4).fill(content).join(" · ");
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-white/10 bg-[#0A0A0A] overflow-hidden py-6 md:py-10"
    >
      <div className="marquee-track flex whitespace-nowrap font-display text-[11vw] md:text-[9vw] leading-none uppercase">
        <span className="mr-16 txt-stroke">{line}</span>
        <span className="mr-16 text-[#1E7FFF]">{line}</span>
      </div>
    </section>
  );
}
